import { useState, useEffect } from 'react'

export const useFetchAllVehicles = ({marvarApi, dispatch, onLogout}) => {
    const [vehicles, setVehicles] = useState([])
    const [loadingFetchVehicles, setLoadingFetchVehicles ] = useState(false) //estado para animacion de carga
    
    const [ execute, setExecute ] = useState(false)
    const executeFetchAllVehicles = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/vehicle/common/get-all-vehicles`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchVehicles(true)
        fetchData()
            .then((resp) => {
                setVehicles(resp.data)
                setLoadingFetchVehicles(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchVehicles(false)
            })
    }, [execute])

    return { vehicles, loadingFetchVehicles, executeFetchAllVehicles }

}

export const useFetchInfoVehicle = ({marvarApi, dispatch, onLogout, Forms, helpers}) =>{
    const { FormVehicle: {formState, setFormState} } = Forms
    const { numberFormatter } = helpers

    // 2. Para mostrar animación de carga
    const [ loadingFetchInfoVehicle, setLoadingFetchInfoVehicle ] = useState(false)

    // 4. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetchInfoVehicle = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/vehicle/common/get-info-vehicle/${formState.idvehicle}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(formState.idvehicle > 0 ){
            setLoadingFetchInfoVehicle(true)
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { data } = resp

                    setFormState((prevState) => ({
                        ...prevState,

                        tipo : data.tipo || '',
                        marca : data.marca || '',
                        modelo : data.modelo || '',
                        linea : data.linea || '',
                        matricula : data.matricula || '',
                        color : data.color || '',
                        motorCC : data.motorCC || '',
                        motorNo : data.motorNo || '',
                        chasis : data.chasis || '',
                        origen : data.origen || '',
                        disponibilidad : data.disponibilidad || '',
                        costo : numberFormatter.format(data.costo) || '',
                        clean_costo: data.costo,
                        clean_costo_total: data.costo_total,
                        costo_total: numberFormatter.format(data.costo_total),
                        
                    }))

                    setLoadingFetchInfoVehicle(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchInfoVehicle(false)
                })
        }
    }, [execute, formState.idcredito])

    return { loadingFetchInfoVehicle, executeFetchInfoVehicle }
}

export const useFetchVehicleImages = ({marvarApi, dispatch, onLogout, Forms}) => {
    const { FormVehicle: {formState, setFormState} } = Forms

    const [vehiclesImages, setVehiclesImages] = useState([])
    
    const [fetchCount, setFetchCount] = useState(0);
    const executeFetchVehicleImages = async () => {
        setFetchCount((prevCount) => prevCount + 1);
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/vehicle/common/get-vehicle-images/${formState.idvehicle}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(formState.idvehicle>0){
            fetchData()
                .then((resp) => {

                    setFormState((prevState) => ({
                        ...prevState,
                        images: resp.data
                    }))
                    
                    setVehiclesImages(resp.data)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
        }
    }, [fetchCount])

    return { vehiclesImages, executeFetchVehicleImages }

}

export const useFetchAllVehicleExpenses = ({marvarApi, dispatch, onLogout, Forms}) => {
    
    const {FormVehicle: {formState}} = Forms
    
    const [vehicleExpenses, setVehicleExpenses] = useState([])
    
    const [ execute, setExecute ] = useState(false)
    const executeFetchAllVehicleExpenses = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/vehicle/vehicle/get-all-expenses/${formState.idvehicle}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(formState.idvehicle>0){
            fetchData()
                .then((resp) => {
                    const data = resp.data.map(item => ({
                        ...item,
                        check_print: false  
                    }))
                    setVehicleExpenses(data)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
        }
    }, [execute])

    return { vehicleExpenses, setVehicleExpenses, executeFetchAllVehicleExpenses }

}

export const useFetchInfoExpense = ({marvarApi, dispatch, onLogout, Forms, helpers}) =>{
    const { FormExpenses: {formState, setFormState} } = Forms
    const { numberFormatter } = helpers


    // 4. Para ejecutar el fetch desde alguna acción
    const [fetchCount, setFetchCount] = useState(0);
    const executeFetchInfoExpense = async () => {
        setFetchCount((prevCount) => prevCount + 1);
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/vehicle/vehicle/get-info-expense/${formState.idexpense}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(formState.idexpense > 0 ){
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { data } = resp

                    setFormState((prevState) => ({
                        ...prevState,
                        title: data.title || '',
                        description: data.description || '',
                        supplier: data.supplier || '',
                        advance: numberFormatter.format(data.advance) || '',
                        expense: numberFormatter.format(data.expense) || '',   
                        clean_advance: data.advance || '',
                        clean_expense: data.expense || '',                       
                    }))

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
        }
    }, [fetchCount])

    return { executeFetchInfoExpense }
}

export const useFetchAllVehicleStatus = ({marvarApi, dispatch, onLogout, Forms}) => {
    
    const {FormVehicle: {formState}} = Forms
    
    const [vehicleStatus, setVehicleStatus] = useState([])
    
    const [fetchCount, setFetchCount] = useState(0);
    const executeFetchAllVehicleStatus = async () => {
        setFetchCount((prevCount) => prevCount + 1);
    }


    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/vehicle/vehicle/get-all-status/${formState.idvehicle}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(formState.idvehicle>0){
            fetchData()
                .then((resp) => {
                    setVehicleStatus(resp.data)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
        }
    }, [fetchCount])

    return { vehicleStatus, executeFetchAllVehicleStatus }
}

export const useFetchInfoStatus = ({marvarApi, dispatch, onLogout, Forms, helpers}) =>{
    const { FormStatus: {formState, setFormState} } = Forms


    // 4. Para ejecutar el fetch desde alguna acción
    const [fetchCount, setFetchCount] = useState(0);
    const executeFetchInfoStatus = async () => {
        setFetchCount((prevCount) => prevCount + 1);
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/vehicle/vehicle/get-info-status/${formState.idestado}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(formState.idestado > 0 ){
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { data } = resp

                    setFormState((prevState) => ({
                        ...prevState,
                        fecha: data.fecha || '',
                        disponibilidad: data.disponibilidad || '',
                        ubicacion: data.ubicacion || '',
                        description: data.descripcion || '',                            
                    }))

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
        }
    }, [fetchCount])

    return { executeFetchInfoStatus }
}

export const useFetchAllAdvance = ({marvarApi, dispatch, onLogout, Forms}) => {
    const [advance, setAdvance] = useState([])

    const [paramsToSearch, setParamsToSearch] = useState({})

    const [ execute, setExecute ] = useState(0)
    const executeFetchAllAdvance = async () => {
        setExecute(prev => prev + 1)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/vehicle/vehicle/get-all-advance/${paramsToSearch.idexpense}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idexpense > 0 ){
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { data } = resp
                    setAdvance(data)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
        }
    }, [execute, paramsToSearch.idexpense])

    return { advance, setParamsToSearch, executeFetchAllAdvance }

}